export const EARNINGS_REPORT_DASHBOARD = 'earnings_report_dashboard'
export const QUARTERLY_STATEMENTS = 'quarterly_statements'
export const EDIT_PROMOTION = 'edit_promo'
export const NEW_PROMOTION = 'new_promo'
export const PROMOTION_DASHBAORD = 'promos'
export const PROMOTION_SUCCESS = 'success_promotion'
export const VIEW_PROMOTION = 'view_promo'
export const BULK_IMPORT = 'bulk_import'
export const HOME = 'home'
export const PAYMENT_DASHBOARD = 'payment_dashboard'
export const PAYMENT_ACCOUNT = 'payment_accounts'
export const PAYMENT_ACCOUNT_SUCCESS = 'success_pay'
export const PAYMENT_ACCOUNTS_NEW_MANAGE = 'payment_new_data_manager'
export const PAYMENT_ACCOUNTS_EDIT_MANAGE = 'payment_edit_data_manager'
export const PAYMENT_ACCOUNTS_ERROR = 'payment_account_error'
export const AGGREMENTS = 'contract'
export const PRINT_AGREEMENT = 'print_contract'
export const SIGN_AGREEMENT = 'post_contract'
export const AGREEMENT_STATUS = 'success_agreement'
export const FOUNDRY_PROFILE = 'foundry_profile'
export const EDIT_FOUNDRY = 'edit_foundry'
export const FOUNDRY_UPDATE_SUCCESS = 'success_foundry_update'
export const SUBMISSIONS_CREATE = 'submissions_id'
export const SUBMISSIONS_CORRECT = 'submissions_correct'
export const SUBMISSIONS_DETAILS = 'submissions_details'
export const SUBMISSIONS_SUPPORT_EDIT = 'submissions_support_edit'
export const SUBMISSIONS_FORMAT_LIVE_EDIT_DETAILS = 'live_submissions_correct'
export const SUBMISSIONS_FORMAT_DETAILS = 'released_submissions_details'
export const SUBMISSIONS_SUPPORT_REVIEW = 'submissions_support_review'
export const SUBMISSION_SUCCESS = 'success_submission'
export const USER_PERMISSIONS = 'user_permissions'
export const BUNDLE_DASHBOARD = 'BundleDashboard'
export const BUNDLE_SUBMISSION_DRAFT = 'BundleSubmissionDraft'
export const BUNDLE_SUCCESS = 'BundleSuccess'
export const APPLICATION_PREVIEW = 'application_preview'
export const NON_UFDA2 = 'non_ufda2'
export const INVENTORY_INGESTION_CREATE = 'InventoryIngestionCreate'
export const INVENTORY_INGESTION_HUB = 'InventoryIngestionHub'
export const MFP_NUMBERS = 'mfp-numbers'
export const DROPSHIP = 'DropShip'
export const UPLOAD_FLIP_FONTS = 'UploadFlipFonts'
export const QUARTERLY_EARNINGS_UPLOAD = 'quarterly-earnings-upload'
export const DASHBOARD = 'dashboard';
export const VERIFY_EMAIL = 'verify_email';
export const TERMINATED_CONTRACT = 'terminated_contract';
export const REACTIVATE_FONT_FAMILIES = 'reactivate_font_families';
